<template>
  <div class="el-pagination">
    <el-pagination
      layout="prev, pager, next"
      :current-page="model.currentPageNum"
      :page-size="model.dispCount"
      :total="model.totalRecordCount"
      @current-change="currentChange"
    ></el-pagination>
  </div>
</template>

<style scoped>
div.el-pagination {
  text-align: center;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

// プロパティ
// model
//  下記の項目をもつ連想配列を指定してください
//    currentPage: 現在のページ番号
//    pageSize: 1ページあたりのデータ件数
//    total: 全データ件数
// イベント
// current-change
//  callback(ページ番号)
@Component
export default class AppPagination extends AppComponent {
  @Prop({ required: true })
  model;

  // イベント
  currentChange (...arg) {
    this.$emit('current-change', ...arg);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppPagination.vue